// Service worker registration for Guard Web — the install half of the PWA layer
// (public/manifest.webmanifest + public/sw.js are the other half).
//
// PWA is progressive enhancement ONLY: if anything here is unavailable or fails, the app
// must behave exactly as it did before this slice. Hence: no-op outside production builds
// (a SW caching the dev server wedges local work), no-op when the browser lacks support,
// and registration errors are swallowed — never surfaced, never thrown.
//
// `nav` and `enabled` are injectable so the gate logic is unit-testable in jsdom (which
// has no real ServiceWorkerContainer) without touching globals.

export function registerServiceWorker(
  nav: Navigator | undefined = typeof navigator === "undefined" ? undefined : navigator,
  enabled: boolean = import.meta.env.PROD,
): void {
  if (!enabled || !nav || !("serviceWorker" in nav)) {
    return;
  }

  const register = (): void => {
    nav.serviceWorker.register("/sw.js").catch(() => {
      // Swallowed deliberately: a failed registration must never break the app.
    });
  };

  // Register after the page has loaded so the SW install never competes with first paint;
  // if the document already finished loading (e.g. late call), register immediately.
  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}
